import { appUserAuthTypes } from '../actions/appUserAuth';

const initialState = {
  email: '',
  otpRequested: false,
  otpVerified: false,
  otpError: null,
  alert: null,
  tenants: [],
  support: false,
  // Latches once the redirect URL is in hand and window.location has been
  // pointed at the target subdomain. Deliberately NOT cleared on success:
  // the navigation is asynchronous, so this document stays alive for a beat
  // after the saga finishes. Without the latch the screen falls back to the
  // picker for that beat, which reads as the list re-rendering itself.
  redirecting: false,
  ongoingRequest: {
    requestOtp: false,
    verifyOtp: false,
    fetchTenants: false,
    requestTenantRedirect: false
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case appUserAuthTypes.REQUEST_OTP_REQUEST:
      return {
        ...state,
        email: action.email,
        otpError: null,
        alert: null,
        ongoingRequest: { ...state.ongoingRequest, requestOtp: true }
      };
    case appUserAuthTypes.REQUEST_OTP_SUCCESS:
      return {
        ...state,
        otpRequested: true,
        ongoingRequest: { ...state.ongoingRequest, requestOtp: false }
      };
    case appUserAuthTypes.REQUEST_OTP_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, requestOtp: false }
      };
    case appUserAuthTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        otpError: null,
        alert: null,
        ongoingRequest: { ...state.ongoingRequest, verifyOtp: true }
      };
    case appUserAuthTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        otpVerified: true,
        otpError: null,
        ongoingRequest: { ...state.ongoingRequest, verifyOtp: false }
      };
    case appUserAuthTypes.VERIFY_OTP_FAILURE:
      return {
        ...state,
        otpError: action.reason || 'invalid',
        ongoingRequest: { ...state.ongoingRequest, verifyOtp: false }
      };
    case appUserAuthTypes.FETCH_TENANTS_REQUEST:
      return {
        ...state,
        alert: null,
        ongoingRequest: { ...state.ongoingRequest, fetchTenants: true }
      };
    case appUserAuthTypes.FETCH_TENANTS_SUCCESS:
      return {
        ...state,
        tenants: action.tenants,
        support: action.support || false,
        ongoingRequest: { ...state.ongoingRequest, fetchTenants: false }
      };
    case appUserAuthTypes.FETCH_TENANTS_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, fetchTenants: false }
      };
    case appUserAuthTypes.REQUEST_TENANT_REDIRECT_REQUEST:
      return {
        ...state,
        alert: null,
        ongoingRequest: { ...state.ongoingRequest, requestTenantRedirect: true }
      };
    case appUserAuthTypes.REQUEST_TENANT_REDIRECT_SUCCESS:
      return {
        ...state,
        redirecting: true,
        ongoingRequest: { ...state.ongoingRequest, requestTenantRedirect: false }
      };
    case appUserAuthTypes.REQUEST_TENANT_REDIRECT_FAILURE:
      return {
        ...state,
        redirecting: false,
        ongoingRequest: { ...state.ongoingRequest, requestTenantRedirect: false }
      };
    case appUserAuthTypes.CHANGE_EMAIL:
      // Back to the email step; keep the typed email prefilled.
      return {
        ...state,
        otpRequested: false,
        otpVerified: false,
        otpError: null,
        alert: null,
        tenants: [],
        support: false,
        redirecting: false,
        ongoingRequest: { ...initialState.ongoingRequest }
      };
    case appUserAuthTypes.SET_ALERT:
      return { ...state, alert: action.alert };
    case appUserAuthTypes.CLEAR_ALERT:
      return { ...state, alert: null };
    default:
      return state;
  }
};

export default reducer;
